import * as t from 'io-ts';

import {makeEnumRuntimeType} from '../../models/api/apiTypes';
import {HttpResponseError} from '../../services/http/httpError';

/*
 * Types.
 */

export enum DownloadTemplateLinkTypesEnum {
  LINK = 'LINK',
  FILE = 'FILE',
}

interface DownloadTemplateUrlLink {
  type: DownloadTemplateLinkTypesEnum.LINK;
  url: string;
}

interface DownloadTemplateFileLink {
  type: DownloadTemplateLinkTypesEnum.FILE;
  url: string;
  name: string;
}

export type DownloadTemplateLink = DownloadTemplateUrlLink | DownloadTemplateFileLink;

/*
 * io-ts.
 */

export enum CustomFieldUploadErrorsEnum {
  NO_HEADER = 'no_header',
  EMPTY_HEADERS = 'empty_headers',
  UNRECOGNIZED_HEADERS = 'unrecognized_headers',
  INVALID_DUPLICATE_HEADERS = 'invalid_duplicate_headers',
  TOO_MANY_ROWS = 'too_many_rows',
  INVALID_FILE_TYPE = 'invalid_file_type',
  PARSE_ERROR_MORE_ROWS_THAN_HEADER = 'parse_error_more_rows_than_header',
  MISSING_HEADER_COLUMN = 'missing_header_column',
  MISSING_FIELDS = 'missing_fields',
  MISSING_NAME = 'missing_name',
  ROWS_ERRORS_WITH_DOWNLOAD = 'rows_errors_with_download',
  INVALIDATE_DUPLICATE_HEADERS = 'invalid_duplicate_headers',
  PARSE_ERROR = 'parse_error',
  INVALID_CUSTOM_FIELD_VALUE = 'invalid_custom_field_value',
  DUPLICATE_IDENTIFIER = 'duplicate_identifier',
  UNKNOWN_ERROR = 'unknown_error',
}
const RCustomFieldUploadErrorsTypes = makeEnumRuntimeType(CustomFieldUploadErrorsEnum);

const RCsvValidationError = t.intersection([
  t.type({
    error: RCustomFieldUploadErrorsTypes,
  }),
  t.partial({
    row: t.union([t.undefined, t.number]),
    file: t.union([t.undefined, t.unknown]),
  }),
]);

export interface CsvValidationError extends t.TypeOf<typeof RCsvValidationError> {
  file: File | undefined; // Correctly type `t.unknown`.
}

export function parseCsvValidationError(error: HttpResponseError): ReadonlyArray<CsvValidationError> {
  // The backend can return a CSV file detailing the different errors.
  if (error.file) {
    return [{error: CustomFieldUploadErrorsEnum.ROWS_ERRORS_WITH_DOWNLOAD, file: error.file, row: undefined}];
  }

  // Otherwise, it will return a list of errors.
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const {invalids = []} = error.body as any;
  const csvErrors = invalids?.map(parseValidationError);
  return csvErrors ?? [];
}

function parseValidationError(invalid: any): CsvValidationError {
  return {
    error: parseCsvErrorType(invalid.error),
    row: invalid.row,
    file: undefined,
  };
}

function parseCsvErrorType(value: any): CustomFieldUploadErrorsEnum {
  return RCustomFieldUploadErrorsTypes.is(value) ? value : CustomFieldUploadErrorsEnum.UNKNOWN_ERROR;
}
